import { css } from '@emotion/core'
import { Button, Theme, useTheme } from 'bold-ui'
import React from 'react'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'

export const ButtonAcessoRnds = () => {
  const history = useHistory()
  const match = useRouteMatch()
  const location = useLocation()
  const theme = useTheme()
  const styles = createStyles(theme)

  const handleClick = () => {
    history.push(`${match.url}/sistemas-externos/rnds`, {
      from: location.pathname,
    })
  }

  return (
    <Button kind='primary' size='medium' style={styles.button} onClick={handleClick}>
      <div css={styles.divSpan}>
        <span>SUS Digital </span>
        <span css={styles.profissionalText}>Profissional</span>
      </div>
    </Button>
  )
}

const createStyles = (theme: Theme) => ({
  button: css`
    padding: 0.3rem 1rem;
    line-height: 1.2rem;
  `,
  profissionalText: css`
    display: block;

    ${theme.breakpoints.up('lg')} {
      display: inline;
    }
  `,
  divSpan: css`
    display: block;
  `,
})
